import Layout from '../views/layout/Layout'

export default {
  path: '/client',
  component: Layout,
  redirect: '/client/clientList',
  name: 'client',
  meta: {title: '客户管理', icon: 'client'},
  children: [
    {
      path: 'clientList',
      name: 'clientList',
      component: () => import('@/views/client/clientList/index'),
      meta: {title: '客户列表', icon: 'client-list'}
    },
    {
      path: 'clientEnter',
      name: 'clientEnter',
      component: () => import('@/views/client/clientEnter/index'),
      meta: {title: '录入客户', icon: 'ums-admin'},
      hidden: true
    },
    {
      path: 'authorizationList',
      name: 'authorizationList',
      component: () => import('@/views/client/authorizationList/index'),
      meta: {title: '授权列表', icon: 'authorization-list'}
    },
    {
      path: 'addAuthorization',
      name: 'addAuthorization',
      component: () => import('@/views/client/addAuthorization/index'),
      meta: {title: '添加授权', icon: 'authorization-list'},
      hidden: true
    },
    {
      path: 'faceSet',
      name: 'faceSet',
      component: () => import('@/views/client/faceSet/index'),
      meta: {title: 'FaceSet分配', icon: 'face-set'}
    },
    {
      path: 'expireHandle',
      name: 'expireHandle',
      component: () => import('@/views/client/expireHandle/index'),
      meta: {title: '过期处理', icon: 'API_LIST'}
    },
  ]
}


// WEBPACK FOOTER //
// ./src/router/client.js